import { z } from 'zod';

export const TotpStatus = [
  'Disabled', // 2FA not set up
  'Pending Setup', // User initiated setup but hasn't completed
  'Enabled', // 2FA active and working
  'Suspended', // Temporarily disabled by admin
  'Recovery Mode', // Using backup codes or recovery process
] as const;

export const TotpStatusSchema = z.enum(TotpStatus);
export type TUserTotpStatus = (typeof TotpStatus)[number];

export const UserRoles = [
  'Company owner',
  'Company administrator',
  'Manufacturer',
  'Installer',
  'Owner',
  'Guest',
  'Unknown',
] as const;
export type TUserRoles = (typeof UserRoles)[number];
export const UserRolesSchema = z.enum(UserRoles);

export const UserStatus = [
  'Active', // User is active and can use the system
  'Maintenance', // Account temporarily in maintenance mode

  'Pending Verification', // Waiting for user to verify account
  'Pending Approval', // Waiting for admin approval
  'Invitation Sent', // Invitation sent but not yet accepted

  'Suspended', // Temporarily restricted access
  'Locked', // Account locked due to security reasons
  'Rejected', // Account application rejected

  'Deactivated', // User-initiated account deactivation
  'Archived', // Account archived for record keeping
  'Expired', // Account expired due to time/policy

  'Unknown',
] as const;
export const UserStatusSchema = z.enum(UserStatus);
export type TUserStatus = (typeof UserStatus)[number];

export const UserSchema = z.object({
  userId: z.string().min(1, 'No user id provided.'),
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),

  role: UserRolesSchema.default('Unknown'),
  status: UserStatusSchema,

  totpStatus: TotpStatusSchema.optional().default('Disabled'),

  subscriptionType: z.string().optional(),
  themePref: z.string().optional(),
  preferredLocale: z.string().optional(),
  marketingConsent: z.string().optional(),

  verificationCode: z.string().optional(),

  updatedAt: z.string().optional(),
  createdAt: z.string().optional(),

  lastAccessTokenAt: z.string().nullable().optional(),
});

export type TUser = z.infer<typeof UserSchema>;
export type TUsers = z.infer<typeof UserSchema>[];
